import React from 'react';
import PropTypes from 'prop-types';

const HeaderTopDropdownNestedItem = ({ children }) => <li className="c-header-dropdown__item">{children}</li>

export default HeaderTopDropdownNestedItem;

HeaderTopDropdownNestedItem.propTypes = {
  children: PropTypes.node.isRequired,
};
